import "./geoPost.scss";
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import MapWithCircles from "../geoMap/GeoMap";
// import { reverseGeocode } from '../geoMap/reverseGeoCode';


const GeoPost = ({ post }) => {
  const [bodyOpen, setBodyOpen] = useState(false);
    
  const verified = false; // Temporary hardcoded verification status

  // Function to toggle body visibility
  const toggleBody = () => {
    setBodyOpen(!bodyOpen);
  };

  return (
    <div className="post">
      <div className="container">
        {/* Post Head */}
        <div className="head" onClick={toggleBody}>
          <div className="userInfo">
            <Link to={`/profile/${post.user.id}`}>
              <img src={post.user.profilePic} alt="" className="profilePic"/>
              <span>{post.user.name}</span>
            </Link>
          </div>
          <div className="targetInfo">
          <Link
                to={`/target/${post.target.id}`}
                style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
              >
                
            <img src={post.target.targetPic} alt="" className="targetPic"/>
                </Link>
            <div className="details">
              
                <span className="targetName">{post.target.name}</span>
              <span className="targetNumber">{post.msisdn.phone_number}</span>
              <span className="status">{post.status}</span>
              <span className="date">{post.timestamp}</span>
            </div>
          </div>
          <div className="reverseGeo">
            <p>{post.data?.location?.reverse_geo}</p>
          </div>
          {post.data && post.data.location ?<MoreHorizIcon />: post.status }
        </div>

        {/* Post Body - Map and content */}
        {bodyOpen && (
          <div className="body">
            <div className="content">
              <p>{post.status}</p>
              <p>{post.timestamp}</p>
            </div>
            <div className="map">
              {/* Hardcoded Map Placeholder */}
              <div className="mapContainer">
                {/* Map Details */}
                { post.data && post.data.location && (
                  <><div className="mapDetails">
                  <span>Latitude: {post.data.location.lat}</span>
                  <span>Longitude: {post.data.location.lng}</span>
                  <span>Radius: {post.data.location.radius}m</span>
                </div>
                <div className="mapPlaceholder">
                <MapWithCircles lat={post.data.location.lat} lng={post.data.location.lng} radius2={post.data.location.radius} radius1={Math.round(post.data.location.radius/2)}/>
                </div></>
        )}
                
              </div>
            </div>
           
          </div>
        )}
      </div>
      <div className="info">
              <div className="item">
                {verified ? <VerifiedIcon /> : <VerifiedOutlinedIcon />}
                3 Verifications
              </div>
              <div className="item">
                <TextsmsOutlinedIcon />
                12 Comments
              </div>
              <div className="item">
                <ShareOutlinedIcon />
                Share
              </div>
            </div>
    </div>
  );
};

export default GeoPost;